import React, {Component} from "react";
import {observer} from "mobx-react";
import {Button, Input} from "@posco/posco-ui-react";
import {mesAutobind} from "@posco/posco-shared";
import {Common} from "@plm/o10-share-front";


@mesAutobind
@observer
class DevPageContainer extends Component {
  state = {
    userInfo: {},
    invbpInfo: {},
    testPageId: "o10b014010",
    testUrl: "/o10t01-front/o10b01-front/o10b014010",
    testUrl2: "/o10t01-front/o10b01-front/o10b014010?test=11",
    testUrl3: "/o10t01-front/o10b01-front/o10b014030/PAFA2022001",
    testUrl4: "/o10t01-front/o10b01-front/o10b012020",
    testUrl4_2: "화면 이름"
  };

  componentDidMount() {
    this.setState({
      userInfo: Common.PotalUtil.getStorageItem("Posco.auth.userInfo"),
      invbpInfo: Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo")
    });
  }

  // componentWillUnmount() {
  //   this.props.empStore.clearEmps();
  // }

  copyToClipboard(val) {
    const t = document.createElement("textarea");
    document.body.appendChild(t);
    t.value = val;
    t.select();
    document.execCommand("copy");
    document.body.removeChild(t);
  }

  copyUserInfo() {
    let copyText = "localStorage.clear(); sessionStorage.clear();";

    const tmpLocal = localStorage;
    for (const key in tmpLocal) {
      if (key !== "length" && key !== "clear" && key !== "getItem" && key !== "key" && key !== "removeItem" && key !== "setItem") {

        copyText += `localStorage.setItem('${key}', '${tmpLocal[key]}');`;
      }
    }

    const tmpSession = sessionStorage;
    for (const key in tmpSession) {
      if (key !== "length" && key !== "clear" && key !== "getItem" && key !== "key" && key !== "removeItem" && key !== "setItem") {
        copyText += `sessionStorage.setItem('${key}', '${tmpSession[key]}');`;
      }
    }
    this.copyToClipboard(copyText);
  }


  render() {
    return (
      <div>
        <p>주소 수정하여 테스트 후 우측 코드 복사하여 사용</p>
        <h3>내부 탭 닫기</h3>
        <Input type="text" value={this.state.testPageId} width={500}
               onChange={(e, data) => {
                 this.setState({testPageId: data.value});
               }}
        />
        <Button className="btnPrm mgr-8" onClick={() => {
          Common.PotalUtil.removePotalTab(this.state.testPageId);
        }}>내부탭 닫기</Button> <br/>
        Common.PotalUtil.removePotalTab("{this.state.testPageId}");
        <br/>
        <h3>내부 탭 열기</h3>
        <Input type="text" value={this.state.testUrl} width={500}
               onChange={(e, data) => {
                 this.setState({testUrl: data.value});
               }}
        />
        <Button className="btnPrm mgr-8" onClick={() => {
          Common.PotalUtil.addPotalTab(this.state.testUrl);
        }}>내부탭 열기</Button> <br/>
        Common.PotalUtil.addPotalTab("{this.state.testUrl}");
        <br/>
        <Input type="text" value={this.state.testUrl2} width={500}
               onChange={(e, data) => {
                 this.setState({testUrl2: data.value});
               }}
        />
        <Button className="btnPrm mgr-8" onClick={() => {
          Common.PotalUtil.addPotalTab(this.state.testUrl2);
        }}>내부탭 열기(쿼리스트링)</Button> <br/>
        Common.PotalUtil.addPotalTab("{this.state.testUrl2}");
        <br/>
        <Input type="text" value={this.state.testUrl3} width={500}
               onChange={(e, data) => {
                 this.setState({testUrl3: data.value});
               }}
        />
        <Button className="btnPrm mgr-8" onClick={() => {
          Common.PotalUtil.addPotalTab(this.state.testUrl3);
        }}>내부탭 열기(프로젝트넘버)</Button> <br/>
        Common.PotalUtil.addPotalTab("{this.state.testUrl3}");
        <br/>
        <p>메뉴내 없는 페이지를 띄워야 할때는 화면명을 2번째 인자로 보낸다</p>
        <Input type="text" value={this.state.testUrl4} width={500}
               onChange={(e, data) => {
                 this.setState({testUrl4: data.value});
               }}
        /><br/>
        <Input type="text" value={this.state.testUrl4_2} width={500}
               onChange={(e, data) => {
                 this.setState({testUrl4_2: data.value});
               }}
        />
        <Button className="btnPrm mgr-8" onClick={() => {
          Common.PotalUtil.addPotalTab(this.state.testUrl4, this.state.testUrl4_2);
        }}>내부탭 열기(메뉴에없는 화면)</Button> <br/>
        Common.PotalUtil.addPotalTab("{this.state.testUrl4}","{this.state.testUrl4_2}");

        <br/>
        <br/>
        <br/>
        <h3>개발에 필요한 localStorage,sessionStorage 복사</h3>
        <p>아래 버튼 클릭 후 로컬 환경 개발자도구 콘솔에 붙여넣어 실행하세요 </p>
        <Button className="btnPrm mgr-8" onClick={this.copyUserInfo}>localStorage / sessionStorage 복사</Button>
        {/*<br/>*/}
        {/*<br/>*/}
        {/*<br/>*/}
        {/*<h3>로그인 계정 userInfo 정보</h3>*/}
        {/*<div className="tableWrap">*/}
        {/*  <table>*/}
        {/*    <tbody>*/}
        {/*    {Object.keys(this.state.userInfo).map(item => {*/}
        {/*      return (*/}
        {/*        <tr key={item}>*/}
        {/*          <th>{item}</th>*/}
        {/*          <td>{this.state.userInfo[item]}</td>*/}
        {/*        </tr>*/}
        {/*      );*/}
        {/*    })}*/}
        {/*    </tbody>*/}
        {/*  </table>*/}
        {/*</div>*/}
        {/*<h3>로그인 계정 invbpInfo 정보</h3>*/}
        {/*<div className="tableWrap">*/}
        {/*  <table>*/}
        {/*    <tbody>*/}
        {/*    {Object.keys(this.state.invbpInfo).map(item => {*/}
        {/*      return (*/}
        {/*        <tr key={item}>*/}
        {/*          <th>{item}</th>*/}
        {/*          <td>{this.state.invbpInfo[item]}</td>*/}
        {/*        </tr>*/}
        {/*      );*/}
        {/*    })}*/}
        {/*    </tbody>*/}
        {/*  </table>*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default DevPageContainer;
